// 前端常量配置

/** localStorage：用户已关闭的公告 ID 列表（JSON 数组） */
export const LS_ANNOUNCEMENTS_DISMISSED = 'phone-hash:announcements-dismissed';

export const FREE_BATCH_LIMIT = 100;  // 每天首次批量免费条数上限
export const BATCH_PRICE_PER_ROW = 0.005;  // 批量处理单价（元/行）
